import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import ConditionalTooltip from '../ConditionalTooltip';
import s from './NetworkBarLink.scss';
var NetworkBarLink = function (_a) {
    var label = _a.label, Icon = _a.icon, url = _a.url, className = _a.className, tabIndex = _a.tabIndex, isSelected = _a.isSelected, _b = _a.isCollapsed, isCollapsed = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    return (React.createElement(ConditionalTooltip, { tooltipContent: t("networkBar.navItems." + label + ".tooltip"), showTooltip: isCollapsed },
        React.createElement("a", { href: url, className: classnames(s['root'], isSelected && s['selected'], isCollapsed && s['collapsed'], className), tabIndex: tabIndex },
            React.createElement(Icon, { disableDefaultColors: true, customSizable: true, className: s['icon'] }),
            !isCollapsed && (React.createElement("span", { className: s['label'] }, t("networkBar.navItems." + label))))));
};
NetworkBarLink.displayName = 'NetworkBarLink';
export default NetworkBarLink;
//# sourceMappingURL=NetworkBarLink.js.map